var jingdian = [
    // —————— 东营区（主城区） ——————
    [118.989450, 37.760706, '黄河口生态旅游区'],
    [118.585424, 37.406009, '揽翠湖旅游度假区'],
    [118.596786, 37.419963, '黄河三角洲动物园'],
    [118.493463, 37.462836, '胜利油田科技展览中心'],
    [118.598910, 37.449171, '东营万象游乐园'],
    [118.233234, 37.382963, '龙居桃花岛旅游度假区'],
    [118.650564, 37.434008, '蓝海逸园'],
    [118.542545, 37.404066, '电文化体验馆'],
    [118.596376, 37.393121, '华林庄园'],
    [118.943978, 37.686520, '积丰园生态旅游区'],
    [118.682761, 37.414491, '清风湖公园'],
    [118.681575, 37.496550, '东营园博园'],

    // —————— 河口区 ——————
    [118.827205, 37.901045, '孤岛槐树林温泉旅游区'],
    [118.510677, 37.883210, '鸣翠湖湿地风景区'],
    [118.424761, 37.475127, '黄河王酒业文化博览园'],
    [118.540467, 37.585320, '绿野仙踪乡村旅游区'],
    [118.789609, 37.848604, '孤岛植物园'],
    [118.661650, 37.434973, '义和镇锦绣庄园'],
    [118.298233, 37.992387, '新户镇果园居'],

    // —————— 垦利区 ——————
    [118.423303,37.571793, '天宁寺文化旅游区'],
    [118.574890, 37.546759, '民丰湖休闲娱乐区'],
    [118.585424, 37.406009, '莲心湾旅游度假区'],
    [118.930182, 37.543662, '东营红滩湿地旅游区'],
    [118.726020, 37.557818, '渤海垦区革命纪念馆'],
    [118.783749, 37.546699, '稻田画风景区'],
    [118.582621,37.571716, '明镜湖旅游区'],
    [118.737383, 37.675909, '黄河口大闸蟹产业园'],
    [118.416958, 37.439237, '郝家绿色生态观光园'],

    // —————— 广饶县 ——————
    [118.466569, 37.058262, '孙子文化旅游区'],
    [118.361111, 37.384066, '红色刘集旅游景区'],
    [118.406168, 37.058161, '东营市历史博物馆（广饶馆区）'],
    [118.429825, 37.089570, '兵圣王酒业旅游区'],
    [118.546510, 37.141913, '青丘文化旅游区'],
    [118.479677, 37.042079, '孙武湖·金水湾景区'],
    [118.479483, 37.041958, '华泰孙武湖温泉旅游区'],
    [118.701069, 37.454389, '阳光奶牛乐园'],

    // —————— 利津县 ——————
    [118.276156, 37.490951, '凤凰城滨河休闲旅游区'],
    [118.226969, 37.479903, '利津县博物馆'],
    [118.255084, 37.490919, '利津县文化活动中心'],
    [118.585424, 37.406009, '北宋金河滩乡村旅游度假区'],
    [118.478917, 37.725485, '汀罗镇铁门关景区'],

    // —————— 东营经济技术开发区 & 农高区 ——————
    [118.678427, 37.402737, '雪莲大剧院'],
    [118.643217, 37.512111, '白鹭园湿地'],
    [118.897927, 37.740367, '知青小镇'],

    // —————— 亲子乐园 & 儿童友好型重点景区 ——————
    [118.598910, 37.449171, '东营万象游乐园'],
    [118.701069, 37.454389, '阳光奶牛乐园'],
    [118.897927, 37.740367, '知青小镇（萌宠互动+手工体验）'],
    [118.596786, 37.419963, '黄河三角洲动物园'],
    [118.479677, 37.042079, '孙武湖·金水湾景区（儿童戏水区）'],
    [118.930182, 37.543662, '东营红滩湿地旅游区（观鸟研学）'],
    [118.226969, 37.479903, '利津县博物馆（文物修复体验）'],
    [118.361111, 37.384066, '红色刘集旅游景区（地道战体验）'],
];

var dongying = [
    {
        name: '景点',
        group: 'base',
        list: jingdian,
        show: true,
        color: 'red'
    }
]


export default dongying